<template>
  <v-layout justify-center>
    <loading :active.sync="busy"/>

    <v-dialog v-model="dialog_status"
      class="dialog-container"
      persistent max-width="400px"
      @keydown.esc="close()">
      
      <v-card>
        <!-- Title -->
        <v-card-title class="card-title">
          <span>{{ $t('change_profile.change_profile') }}</span>
        </v-card-title>

        <v-card-text>
          <div v-if="image_existed" class="photo">
            <div class="photo-image">
              <img :src="user_image" alt="">
            </div>
            <div class="photo-button" @click="initiate">
              <v-btn small depressed color="primary">
                <span class="input-text">
                  {{ $t('change_profile.change_photo') }}
                </span>
                <div class="input">
                  <image-uploader
                    ref="image"
                    style="{width: 120px}"
                    accept="image/png, image/jpeg, image/jpg, image/gif"
                    @input="uploadFile"
                    :autoRotate=true
                    :preview=false
                    outputFormat="verbose"
                    :maxWidth="245">
                  </image-uploader>
               </div>
              </v-btn>
              <v-btn small text @click="removeFile">
                {{ $t('change_profile.remove_photo') }}
              </v-btn>
            </div>
          </div>
          <div v-else class="photo">
            <div class="photo-image">
              <v-icon size="120px">mdi-account-circle</v-icon>
            </div>
            <div class="photo-button" @click="initiate">
              <v-btn small depressed color="primary">
                <span class="input-text">
                  {{ $t('change_profile.upload_photo') }}
                </span>
                <div class="input">
                  <image-uploader
                    ref="image"
                    accept="image/png, image/jpeg, image/jpg, image/gif"
                    @input="uploadFile"
                    :autoRotate=true
                    :preview=false
                    outputFormat="verbose"
                    :maxWidth="245">
                  </image-uploader>
               </div>
              </v-btn>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="actions">
          <v-btn small @click="close" text>
            {{ $t('change_profile.close') }}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      busy: false,
    }
  },

  computed: {
    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },
    ...mapGetters({
      image_existed: 'user/image_existed',
      user_image: 'user/user_image',
    }),
  },

  async created() {
    try {
      await this.$store.dispatch('user/getUserInfo')
    } finally {
      let has_img = this.$store.getters['user/has_img']
      if (!!has_img) {
        await this.$store.dispatch('user/getUserImage')
      } else {
        await this.$store.commit('user/removeUserImage')
      }
    }
  },

  methods: {
    close() {
      this.$emit('update:dialog', false)
    },

    async uploadFile(verbose) {
      var file = this.dataURLtoFile(verbose.dataUrl, 'img.png')
      let form_data = new FormData()
      form_data.append('image', file)
      await this.$store.dispatch('user/setUserImage', form_data)
      this.$analytics.logEvent('click', { name: 'account_btn_changeProfilePhoto' })
    },

    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    },

    async removeFile() {
      await this.$store.dispatch('user/deleteUserImage')
    },

    initiate() {
      this.$refs.image.$el.children[1].value=""
    },
  },

}
</script>

<style scoped>
  .photo {
    padding-top: 10px;
    display: grid;
    grid-template-columns: 50% 50%;
  }

  .photo > div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .photo-button button {
    margin: 5px;
  }

  .photo-image {
    display: flex;
    justify-content: flex-end;
  }

  img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
    }

  .actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center; 
    opacity: 0;
  }

  .input>div {
    width: 100%;
  }

  input {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/account/ChangeProfilePhoto.vue